import React from "react";
import { useTheme } from "./ThemeProvider";

export default function ThemeModal({ isOpen, onClose }) {
    const { themeId, setThemeId, themes, currentTheme } = useTheme();
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md mx-auto relative z-[10000]">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold" style={{ color: 'var(--color-text)' }}>Color Theme</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl font-bold focus:outline-none transition-colors"
                    >
                        ×
                    </button>
                </div>
                <div className="space-y-4">
                    <select
                        value={themeId}
                        onChange={e => setThemeId(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none transition-all"
                        style={{ color: 'var(--color-text)' }}
                    >
                        {themes.map((theme) => (
                            <option key={theme.id} value={theme.id}>{theme.name}</option>
                        ))}
                    </select>
                    <div className="flex justify-center mt-6">
                        <div className="flex flex-col items-center">
                            <div
                                className="w-16 h-16 rounded-full border-4 border-gray-200 shadow-lg transition-colors"
                                style={{ backgroundColor: currentTheme.color }}
                            ></div>
                            <span className="text-sm mt-3 font-medium" style={{ color: 'var(--color-text)', opacity: 0.7 }}>
                                Selected Color
                            </span>
                        </div>
                    </div>
                    <div className="flex justify-center mt-8">
                        <button
                            onClick={onClose}
                            className="px-8 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors focus:outline-none"
                        >
                            Done
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
